import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { GroupEntity } from './group.entity';
import { PromoEntity } from './promo.entity';

// Item assignment by item group. Members resolved to items at engine
// evaluation time via the existing item_group junction. The `role` matches
// promo_item.role semantics (BUY = qualifier, GET = reward).
@Index('promo_item_group_pk', ['fkPromoId', 'fkGroupId', 'role'], {
	unique: true,
})
@Entity('promo_item_group')
export class PromoItemGroupEntity extends BaseEntity {
	@Column('int', { name: 'fk_promo__id', unsigned: true })
	public fkPromoId!: number;

	@Column('int', { name: 'fk_group__id', unsigned: true })
	public fkGroupId!: number;

	@Column('varchar', { name: 'role', length: 8, default: () => "'BUY'" })
	public role!: 'BUY' | 'GET';

	@ManyToOne(() => PromoEntity, (promo) => promo.promoItemGroups, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_promo__id', referencedColumnName: 'id' }])
	public fkPromo!: PromoEntity;

	@ManyToOne(() => GroupEntity, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_group__id', referencedColumnName: 'id' }])
	public fkGroup!: GroupEntity;
}
